import type {DiffLine} from '@github-ui/diff-lines'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import type {QueryKey} from '@github-ui/react-query'
import {reactFetch} from '@github-ui/verified-fetch'
import type {ComparisonInfo} from '../../stores/slices/comparison-info'

export type ContextLineRange = {
  start: number
  end: number
}

export type ContextLineResponse = {
  diffEntryLines?: DiffLine[]
}

export function diffContextLinesKey(basePath: string, path: string, baseOid: string, headOid: string): QueryKey {
  return [PageData.diffContextLines, basePath, path, baseOid, headOid]
}

/**
 * Fetches the context lines for a given diff entry
 */
export async function fetchInjectedContextLines({
  contextLineRanges,
  basePath,
  path,
  w = '0',
  fullDiff,
  effectiveRange,
}: ComparisonInfo & {
  basePath: string
  contextLineRanges: ContextLineRange[]
  path: string
  w?: string
}): Promise<ContextLineResponse | undefined> {
  const params = new URLSearchParams()
  params.append('path', path)
  for (const contextLineRange of contextLineRanges) {
    params.append('context_line_ranges[]', JSON.stringify(contextLineRange))
  }
  params.append('w', w) // Use the provided w value

  if (effectiveRange.baseOid === fullDiff.baseOid) {
    params.append('range', effectiveRange.headOid)
  } else {
    params.append('range', `${effectiveRange.baseOid}..${effectiveRange.headOid}`)
  }

  const baseFetchUrl = `${basePath}/page_data/${PageData.diffContextLines}?${params.toString()}`
  const response = await reactFetch(baseFetchUrl)

  if (response.ok) {
    const data = await response.json()
    return data ?? undefined
  }
}
